import React, { useEffect, useState } from "react";
import { api } from "@finance/lib/api";
import { LockSimple } from "@phosphor-icons/react";

let _cache = null;

export function refreshPeriodCache() { _cache = null; }

// Subtle inline hint shown on entry forms when the selected date's month is locked/closed.
export function LockedPeriodBanner({ date, className = "" }) {
  const [periods, setPeriods] = useState(_cache || []);
  useEffect(() => {
    if (_cache) { setPeriods(_cache); return; }
    api.get("/periods").then((r) => { _cache = r.data || []; setPeriods(_cache); }).catch(() => {});
  }, []);
  const month = (date || "").slice(0, 7);
  if (!month) return null;
  const p = periods.find((x) => x.period === month);
  if (!p || (p.status !== "locked" && p.status !== "closed")) return null;
  const label = new Date(month + "-01").toLocaleString("en-US", { month: "long", year: "numeric" });
  return (
    <div data-testid="locked-period-banner" className={`flex items-center gap-2 rounded-sm border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-700 ${className}`}>
      <LockSimple size={14} weight="fill" />
      <span>{label} is <strong>{p.status}</strong> — this entry will be rejected on save. Ask Ronick to unlock the period.</span>
    </div>
  );
}

export default LockedPeriodBanner;
